// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';

import type {Node} from 'react';

type Props = {|
  children: Node,
  noMargin?: boolean,
|};

export const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    height: 64,
  },
  filterWrap: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    // display: 'inline-block',
    alignItems: 'flex-start',
    // flexWrap: 'nowrap',
    // width: `calc(100% + ${theme.spacing(3)})`,
    // margin: theme.spacing(2, -4, 2, 0),
    margin: theme.spacing(2, 0, 2, 0),
    // paddingRight: theme.spacing(3),
    // overflowX: 'auto',
    // marginLeft: theme.spacing(-3),
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(2, -2),
      // margin: theme.spacing(2, 0, 2, 0),
      // flexDirection: 'column',
    },
  },
}));

export default function HorizontalFilter(props: Props) {
  const {children, noMargin = false} = props;
  const classes = useStyles();
  return (
    // <Grid container direction="column" className={classes.filterWrap}>
    <div className={classes.container}>
      <div
        className={classes.filterWrap}
        style={{
          marginTop: noMargin ? 0 : undefined,
          marginBottom: noMargin ? 0 : undefined,
        }}
      >
        {children}
      </div>
    </div>
    // </Grid>
  );
}

HorizontalFilter.propTypes = {
  children: PropTypes.node.isRequired,
  noMargin: PropTypes.bool,
};
